// CountdownRenderer.js
import React from 'react';
import CountdownTimerforbid from './countdowntimerforbid';

const CountdownRenderer = (props) => {
  const indent = props.data;

  if (indent.is_draft === 1) {
    return null;
  }

  const biddingWindow = indent.bidding_window;
  const createDate = indent.indent.create_date; // safe check

  return (
    <span style={{ fontSize: '13px', fontWeight: 500 }}>
      {biddingWindow && createDate ? (
        <CountdownTimerforbid
          indent_id={indent.indent_id}
          biddingWindow={biddingWindow}
          createDate={createDate}
          bidding_timer_ends={indent.bidding_timer_ends}
        />
      ) : (
        <span style={{ color: 'blue' }}>--:--:--</span>
      )}
    </span>
  );
};

export default CountdownRenderer;
